import IEnum from '../interfaces/IEnum';

export const FilterTypes: IEnum = {
    enum: {
        CHECKBOX: 0,
        DATE: 1,
        INPUT: 2,
        TOGGLEMULTIPLE: 3
    }
};